  
                        <nb-card *ngIf="stream"   style="margin-bottom: 1rem !important;"
 class="own-scroll">
                            <nb-card-header>
				<div style="display:flex">
                              <div  style="display:flex;   cursor:pointer;  margin-top: auto;  margin-bottom: auto;" 
	[class.unvisiblePanelLabel]="panelVisibility.isUnvisible('keyAccess')"	 (click)="panelVisibility.toggleVisibility('keyAccess')">Доступ по ключу</div>  
<div  style="display:flex; margin-left:auto; cursor:pointer;  margin-top: auto;
    margin-bottom: auto;">
	
				   <nb-toggle  
					[disabled]="(stream.saleMode === true &&  keysOn ) && authService.currentTariff?.saleAvailable"
				      labelPosition="left"
				      [(checked)]="keysOn" 
				      (checkedChange)="toggleKeysOn()" 
				      status="primary">
				      <span *ngIf="keysOn">Включений</span>
				      <span *ngIf="!keysOn">Відключений</span>
				    </nb-toggle>

   </div>
				</div>
                            </nb-card-header>


                            <nb-card-body  [style.padding]="panelVisibility.isUnvisible('keyAccess') ? '0': ''"  class="keysCardBody">
                                 <div #keysRef >
                            <div *ngIf="!panelVisibility.isUnvisible('keyAccess')" [@visibilityPanelAnimation]>
                                <div class="keysList"  *ngFor="let group of accessKeys">
                                    <div   *ngFor="let key of group.keys">  
                                        <div> <span *ngIf="key.buyerEmail" ><nb-icon class="keyCard" pack="eva" icon="credit-card-outline"></nb-icon></span> {{key.password}}  <span *ngIf="key.chatName" > - {{key.chatName}} </span> <span *ngIf="key.buyerEmail" > - {{key.buyerEmail}} </span> </div>
                                    </div>  
          
                                    <hr/>
                                </div>
                
                        </div>
		                 </div>
                            </nb-card-body>       
 
                            <nb-card-footer  *ngIf="!panelVisibility.isUnvisible('keyAccess')" [@visibilityPanelAnimation] >
                                <div style="display: flex;">
                                    <div style="display: flex;">
                                        <a (click)="copyAllKeysToClipboard(keysRef)" *ngIf="keysCount" href="javascript:;">Копіювати</a>

                                    </div>
                                    <div style="display: flex; margin-left: auto;">
                                        <a (click)="downloadAllKeysInTxt(keysRef)" *ngIf="keysCount" href="javascript:;">Завантажити *.txt</a>

                                    </div>
                                </div>

  				<div style="display: flex; margin-top:10px;">
                                    <div style="display: flex;">
                                        <span>Кількість: {{keysCount || 0}}</span>

                                    </div>
                                    <div style="display: flex; margin-left: auto;">
                                        <a class="text-danger" *ngIf="(!stream.saleMode || !authService.currentTariff?.saleAvailable) && keysCount" (click)="openRemoveModal(confirmDeleteKeys,$event)" href="javascript:;">Видалити ключі</a>

                                    </div>
                                </div>
                             
                                </nb-card-footer>

                           <nb-card-footer  *ngIf="!panelVisibility.isUnvisible('keyAccess')" [@visibilityPanelAnimation]  >
                                <div style="display: flex;"> 
                                    <div style="display: flex;">
                                        <button nbButton status="primary"  [disabled]="stream.saleMode === true   && authService.currentTariff?.saleAvailable" (click)="openModal(generateKeys,$event)">Генерувати</button>
                                    </div>
                                    <div style="display: flex; margin-left: auto;">
                                     <button nbButton status="primary" [disabled]="stream.saleMode === true && authService.currentTariff?.saleAvailable" (click)="openModal(loadListModal,$event)">Додати</button>

                                    </div>
                                </div>
                             
                                </nb-card-footer>

		 

                            </nb-card>
 
  


 <ng-template #confirmDeleteKeys let-data let-ref="dialogRef">
      <nb-card>
        <nb-card-header>

    <div style="display:flex; width:100%">
      <span>Підтвердіть видалення</span>   
       <span style="display:flex; margin-left:auto; cursor: pointer; "  (click)="ref.close()">
<nb-icon [icon]="'close-outline'" pack="eva"></nb-icon> 
	</span>  
    </div>

	</nb-card-header>

        <nb-card-body>
	<p>Ця дія видалить всі ключі даного стріму безповоротно!</p>
	</nb-card-body>
        <nb-card-footer>
	
	<div>
	
          <button style="margin-right:15px" nbButton status="danger" (click)="clearAllKeys(ref)">Видалити</button>

          <button nbButton status="basic"  (click)="ref.close()">Скасувати</button>
	</div>

        </nb-card-footer>
      </nb-card>
    </ng-template>


                   
 <ng-template #generateKeys let-data let-ref="dialogRef">
      <nb-card>
        <nb-card-header>

    <div style="display:flex; width:100%">
      <span>Скільки ключів згенерувати?</span>   
      
    </div>

	</nb-card-header>

        <nb-card-body>

 <div class="keyGeneratePanel">
                       
                        <div class="keyGenerateInputWrapper">
                              
                               <div>   <input type="number" nbInput (change)="keyGeneratorQuantity = $event.target.value"  [value]="keyGeneratorQuantity" placeholder="0" /> </div>  <div> <span> Кількість<br/> ключів </span> </div>
                        </div>
                        
                    </div>


	</nb-card-body>
        <nb-card-footer>
	
	<div>
	
          <button style="margin-right:15px" nbButton status="primary" (click)="genereteKeys(ref)">Генерувати</button>

          <button nbButton status="basic"  (click)="ref.close()">Скасувати</button>
	</div>

        </nb-card-footer>
      </nb-card>
    </ng-template>





	

 <ng-template #loadListModal let-data let-ref="dialogRef">
      <nb-card>
        <nb-card-header>

    <div style="display:flex; width:100%">
      <span>Додавання ключів</span>   
        
    </div>

	</nb-card-header>

        <nb-card-body>
	<div class="uploadKeys">
		<p>Кожен з нового рядка</p>
		<div>

			<textarea [disabled]="keysUploadDisabled" #keysInput fullWidth nbInput></textarea>

		</div>
		<div class="msg text-warning">Дозволено використовувати латинські літери A-z, цифри 0-9, а також символи @. - _ </div>
	</div>

	</nb-card-body>
        <nb-card-footer>
	
	<div>
	
          <button style="margin-right:15px" [disabled]="keysUploadDisabled" nbButton status="primary" (click)="loadKeysFromList(keysInput,ref)"  >Додати ключі</button>

          <button nbButton status="basic" [disabled]="keysUploadDisabled" (click)="ref.close()">Скасувати</button>
	</div>

        </nb-card-footer>
      </nb-card>
    </ng-template>




  
<ng-template #loading>
    <div style="position: absolute; z-index: 777; width:100%; height:100%; top:0; left: 0; display: flex; align-self: center;">
    <div style="margin: auto;"> 
         <app-loader></app-loader>
     </div>
    </div>
</ng-template> 
